import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { Button } from './ui/Button';
const includes = ['Complete 7-Day Feeding Framework', 'Portion & Treat Calculator (Bonus)', 'Weekly Feeding Stability Guide (FREE Bonus)', 'Instant Digital Access', 'One-Time Payment'];
export function CTASection() {
  return <section id="offer" className="py-24 bg-[#F8FAFC]" data-id="element-59">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1E293B]" data-id="element-62">
            Ready to Make Mealtime Simple?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-white rounded-xl border border-[#E2E8F0] p-8 md:p-12 text-center shadow-sm" data-id="element-63">
          <h3 className="text-2xl font-bold text-[#1E293B] mb-8" data-id="element-64">
            French Bulldog Smart Feeding System™
          </h3>

          {/* Product Bundle Visual */}
          <div className="flex items-end justify-center gap-6 md:gap-8 mb-10" data-id="element-65">
            {/* Main Product */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="flex flex-col items-center" data-id="element-66">
              <div className="relative w-32 md:w-40" data-id="element-67">
                <img src="https://cdn.magicpatterns.com/uploads/pJfJnV9asUpC8TaTd7NRCV/ChatGPT_Image_Mar_2,_2026,_08_05_55_PM.png" alt="French Bulldog Smart Feeding System" className="w-full rounded-md shadow-lg" data-id="element-68" />
              </div>
              <span className="text-xs md:text-sm font-semibold text-[#1E293B] mt-3 text-center leading-tight" data-id="element-69">
                Smart Feeding
                <br data-id="element-70" />
                System
              </span>
            </motion.div>

            {/* Plus Sign */}
            <div className="text-2xl md:text-3xl font-bold text-[#0F766E] mb-8" data-id="element-71">
              +
            </div>

            {/* Free Bonus */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex flex-col items-center" data-id="element-72">
              <div className="relative w-28 md:w-36" data-id="element-73">
                <div className="absolute -top-3 -right-3 z-10" data-id="element-74">
                  <span className="inline-flex items-center gap-1 px-2 py-1 bg-[#0F766E] text-white text-[10px] md:text-xs font-bold rounded-full shadow-md" data-id="element-75">
                    <Gift className="w-3 h-3" data-id="element-76" />
                    FREE
                  </span>
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/rDd9jWePAEbwk3bz8gj7T3/ChatGPT_Image_Mar_2,_2026,_06_55_26_PM.png" alt="Weekly Feeding Stability Guide - Free Bonus" className="w-full rounded-md shadow-lg" data-id="element-77" />
              </div>
              <span className="text-xs md:text-sm font-semibold text-[#1E293B] mt-3 text-center leading-tight" data-id="element-78">
                Feeding Stability
                <br data-id="element-79" />
                Guide
              </span>
            </motion.div>
          </div>

          <ul className="space-y-3 mb-8 text-left max-w-sm mx-auto" data-id="element-80">
            {includes.map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-81">
                <CheckCircle2 className="w-5 h-5 text-[#0F766E] flex-shrink-0" data-id="element-82" />
                <span className="text-[#475569]" data-id="element-83">{item}</span>
              </li>)}
          </ul>

          <div className="mb-8" data-id="element-84">
            <span className="text-5xl font-bold text-[#1E293B]" data-id="element-85">Only $17</span>
          </div>

          <Button size="lg" fullWidth className="mb-4 text-lg" onClick={() => window.open('https://zensturia.com/cart/51508367163709:1', '_blank')} data-id="element-86">
            Get Instant Access Now
          </Button>

          <p className="text-sm text-[#94A3B8] mb-8" data-id="element-87">
            Secure checkout · No subscription · Instant download
          </p>

          <div className="pt-6 border-t border-[#E2E8F0]" data-id="element-88">
            <h4 className="font-semibold text-[#1E293B] mb-2" data-id="element-89">
              30-Day Satisfaction Guarantee
            </h4>
            <p className="text-sm text-[#475569] leading-relaxed" data-id="element-90">
              Try the system for 30 days. If you don't feel more confident and
              in control of feeding, you're fully covered.
            </p>
            <p className="text-sm text-[#0F766E] font-semibold mt-2" data-id="element-91">
              Zero risk.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}